import './../css/main.sass'
import 'bootstrap/js/dist/carousel'
import 'bootstrap/js/dist/dropdown'
import 'bootstrap/js/dist/collapse'
import './partials/navbar.js'
import '../../node_modules/babel-polyfill'
import { determineHeroImages } from './components/determineHeroImage.js'
import { getBranchen } from './api/branchen-api.js'
import 'bcswipe'
import Vue from 'vue/dist/vue.esm'
import VueMq from 'vue-mq'


let store = {
    debug: true,
    state: {
        baseUrl: process.env.BACKEND_BASE_URL,
        defaultFilialeIcon: ICON_FALLBACK,
        searchUpdated: false,
        search: {},        
        loading: true
    },
    async setSearch(searchObject) {
        searchObject = await formatWantedJson(await determineHeroImages(searchObject))
        this.state.search = searchObject
        this.state.loading = false
        this.state.searchUpdated = true
    },
}

Vue.use(VueMq, {
    breakpoints: {
        mobile: 790,
        tablet: 1320,
        desktop: Infinity,
    }
})

let body = new Vue({
    el: '#bs-body',
    data: store.state,
    computed: {},
    methods: {
        needCollapsible: function(cat) {
            return (cat.prems.length + cat.frees.length) > 3 || (cat.prems.length > 0 && cat.frees.length > 0);
        },
        getFirstDisplayTitle: function(cat) {
            if (cat.prems.length > 0)
                return "Premium Partner"
            else
                return "Kostenlose Basiseinträge"
        },
        getFirstDisplayChunk: function(cat) {

            if (cat.prems.length > 0)
                return cat.prems.slice(0, Math.min(cat.prems.length, 3))
            else
                return cat.frees.slice(0, Math.min(cat.frees.length, 3))
        },
        getSecondDisplayChunk: function(cat) {
            if (cat.prems.length > 3)
                return cat.prems.slice(3, cat.prems.length)
            else if (cat.prems.length == 0)
                return cat.frees.slice(3, cat.frees.length)
        },
        hasThirdDisplayChunk: function(cat) {
            return cat.prems.length > 0 && cat.frees.length > 0
        },
        getCollapsibleId: function(idx, prepend = '') {
            return prepend + "bsCollapsible" + idx
        },
        getCarouselId: function(idx, prepend = '') {
            return prepend + "bsCarousel" + idx
        },
        goToFiliale: function(item) {
            if (item !== undefined)
                window.location.href = "business.html?filiale=" + item.id;
        }
    },
    mounted(){
        window.addEventListener('scroll', function() {
            if ($(this).scrollTop() >= 50) {
                $('#backToTop').fadeIn(200);
                $('.cookie-data').addClass('cookie-data-animation')
                $(".navbar-style-dark").find(".navbar").addClass("nav-solid");
    
            } else {
                $('#BackToTop').fadeOut(200);
                $('.cookie-data').removeClass('cookie-data-animation')
                $(".navbar-style-dark").find(".navbar").removeClass("nav-solid");
            }
        });

        $('#backToTop').click(function() {
            $('body,html').animate({
                scrollTop: 0
        }, 500);});
    },
    updated(){
        if(this.searchUpdated){
            this.searchUpdated = false;
            $('#business-search .carousel').bcSwipe({ threshold: 50 });

            let carousels = $('#business-search .carousel');
            for(let i = 0; i < carousels.length; i++){
                let that = carousels[i];                
                $(that).bind("slid.bs.carousel", function(event){                    
                    let ol = $(that).find(".many-indicators")[0];                    
                    if(ol != undefined){
                        let li = $(ol).find("li.active")[0];
                        let liWidth = parseInt($(li).css("width")) + parseInt($(li).css("marginRight")) + parseInt($(li).css("marginLeft"));
                        let olWidth = parseInt($(ol).css("width"));
                        let olDistanceLeft = ol.getBoundingClientRect().left;
                        let liDistanceLeft = li.getBoundingClientRect().left;
                        let sum = liDistanceLeft - olDistanceLeft;
                        let distance;                 
                        
                        // if indicator is not visible inside ol
                        if(sum > 0){                            
                            if(sum >= olWidth){
                                distance = $(ol).scrollLeft() + (liDistanceLeft - liWidth);
                            }
                        } else {
                            if(event.direction == "right"){
                                distance = $(ol).scrollLeft() - (olWidth - parseInt($(li).css("marginRight")));
                            } else {
                                distance = 0;
                            }
                        }

                        if(distance != undefined){
                            $(ol).scrollLeft(distance);
                        }                        
                    }
                });
            }
        }
    }   
})



function fetchSearchData(searchString, searchCategory) {

    let api = process.env.BACKEND_BASE_URL + "/api/filialen/search?q=" + searchString + "&cat=" + searchCategory
    fetch(api)
        .then(response => response.json())
        .then(json => {
            json.filialen = json
            json.searchQuery = searchString
            store.setSearch(json)
        })
}

function fetchSearchDataSearchTag(searchTag) {
    let api = process.env.BACKEND_BASE_URL + "/api/filialen/searchViaTag?tag=" + searchTag
    fetch(api)
        .then(response => response.json())
        .then(json => {
            if (searchTag !== undefined) {
                json.searchQuery = searchTag
            }
            json.filialen = json
            store.setSearch(json)
        })
}

function fetchSearchDataAcception() {
    let api = process.env.BACKEND_BASE_URL + "/api/filialen/acceptsDummeklemmerCard"
    fetch(api)
        .then(response => response.json())
        .then(json => {
            json.filialen = json
            json.searchQuery = "DumeklemmerCard"
            store.setSearch(json)
        })
}

function fetchSearchDataSell() {
    let api = process.env.BACKEND_BASE_URL + "/api/filialen/sellsDummeklemmerCard"
    fetch(api)
        .then(response => response.json())
        .then(json => {
            json.filialen = json
            json.searchQuery = "DumeklemmerCard"
            store.setSearch(json)
        })
}

function fetchSearchDataCashbackCard(){
    let api = process.env.BACKEND_BASE_URL + "/api/filialen/acceptsCashbackCard"
    fetch(api)
        .then(response => response.json())
        .then(json => {
            json.filialen = json
            json.searchQuery = "Ratingen Card"
            store.setSearch(json)
        })
}

function findGetParameter(parameterName) {
    let result = null,
        tmp = [];
    location.search
        .substr(1)
        .split("&")
        .forEach(function(item) {
            tmp = item.split("=");
            if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1]);
        });
    return result;
}

async function formatWantedJson(source) {

    let ids = []    
    let formattedSource = {}
    let searchQuery = source.searchQuery

    if (source.length > 0) {

        for(let i = 0; i < source.filialen.length; i++) {
            let branchenArray = source.filialen[i].branchen_ids.split(",");
            for(let j = 0; j < branchenArray.length; j++) {
                if(ids.indexOf(parseInt(branchenArray[j])) === -1){
                    ids.push(parseInt(branchenArray[j]));
                }
            }
        }

        let cats = [];
        for(let i = 0; i < ids.length; i++){
            let temp = {};
            let premTemp = [];
            let freeTemp = [];
            
            getBrancheName(ids[i]).then(function(result){temp.name = result;});
            for(let j = 0;j < source.filialen.length; j++) {
                let filialenIds = source.filialen[j].branchen_ids.split(",");
                
                for (let k = 0;k < filialenIds.length; k++){
                    if(filialenIds[k].toString() == ids[i]) {
                        if(source.filialen[j].istPremium == 1) {
                            premTemp.push(source.filialen[j]);
                        } else {
                            freeTemp.push(source.filialen[j]);
                        }
                    } 
                }
            }
            temp.prems = premTemp;
            temp.frees = freeTemp;
            cats.push(temp);
        }
        formattedSource.cats = cats;
    }
    formattedSource.searchQuery = searchQuery
    return formattedSource
}

async function getBrancheName(id){
    id = id.toString();
    let desiredName = "";
    let branchenNamen = await getBranchen()
    for(let i = 0; i < branchenNamen.length; i++){
        
        if(branchenNamen[i].id == id){
            desiredName = branchenNamen[i].name;
        } else {
            let subbranchen = branchenNamen[i].sub_branchen;
            for(let j = 0; j < subbranchen.length;j++){

                if(subbranchen[j].id == id){
                    desiredName = branchenNamen[i].sub_branchen[j].name;
                } else{
                    let subsubbranchen = branchenNamen[i].sub_branchen[j].sub_branchen;
                    for(let k = 0; k < subsubbranchen.length;k++){

                        if(subsubbranchen[k].id == id){
                            desiredName = branchenNamen[i].sub_branchen[j].sub_branchen[k].name;
                        }
                    }
                }
            }
        }        
    }
    return desiredName;
}


function processRequest() {
    // search via input
    let q = findGetParameter("q")
    let cat = findGetParameter("cat")
    if (q != null || cat != null) {
        fetchSearchData(q, cat)
        return
    }
    // search via searchTag
    let tag = findGetParameter("tag")
    if (tag != null && tag.length > 0) {
        fetchSearchDataSearchTag(tag)
        return
    }
    let card = findGetParameter("acceptCard")
    if (card != null) {
        fetchSearchDataAcception()
        return
    }
    let sellCard = findGetParameter("sellCard")
    if (sellCard != null) {
        fetchSearchDataSell()
        return
    }
    let cashback = findGetParameter("cashbackCard")
    if (cashback != null) {
        fetchSearchDataCashbackCard()
        return
    }
}

if (process.env.NODE_ENV === "development" || process.env.NODE_ENV === "staging" || process.env.NODE_ENV === 'production') {
    processRequest()
} else {
    console.error("No content loading for this build mode defined.")
}

$('#cookie-bot-btn').unbind('click');
$('#cookie-bot-btn').click(function() {
    $('#cookie-data-wrap').toggleClass('donot-display');
});